// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8DfSt","left":"styles_left__GyR0P"};